// extracted by mini-css-extract-plugin
export default {"skeleton":"UG_B9X","shine-lines":"VCj7Eb"};